import {
  CODE_LENGTH,
  KEYPAD_DIGITS,
  type Difficulty,
} from "./types.js";

export const RTP = 0.98;

/**
 * Keypad Defuse multiplier.
 *
 *   safe_per_pos = (KEYPAD_DIGITS - D) / KEYPAD_DIGITS
 *   fair_mult_per_pos = 1 / safe_per_pos = KEYPAD_DIGITS / (KEYPAD_DIGITS - D)
 *   M(k, D) = RTP * (KEYPAD_DIGITS / (KEYPAD_DIGITS - D))^k
 *
 *   k = positions already unlocked (0..CODE_LENGTH)
 *   D = bomb digits per position (difficulty)
 *
 *   House edge = 1 - RTP applied once over the whole run;
 *   expected value per pick equals the RTP since
 *   safe_per_pos * M(k, D) / M(k-1, D) = safe_per_pos * (10/(10-D)) = 1
 *   => EV_total = P(all safe) * M(k, D) = (safe^k) * RTP * (1/safe)^k = RTP.
 */
export function multiplier(picks: number, difficulty: number): number {
  if (picks < 0 || picks > CODE_LENGTH) {
    throw new Error(`picks out of range: ${picks}`);
  }
  if (difficulty < 1 || difficulty >= KEYPAD_DIGITS) {
    throw new Error(`difficulty out of range: ${difficulty}`);
  }
  if (picks === 0) return 1;
  const step = KEYPAD_DIGITS / (KEYPAD_DIGITS - difficulty);
  return RTP * Math.pow(step, picks);
}

export function multiplierTable(difficulty: Difficulty): number[] {
  const out: number[] = [];
  for (let k = 0; k <= CODE_LENGTH; k++) out.push(multiplier(k, difficulty));
  return out;
}

export function round2(x: number): number {
  return Math.round(x * 100) / 100;
}

export { CODE_LENGTH, KEYPAD_DIGITS };
